module.exports = __webpack_public_path__ + "img/default-image0.a6cfee05.png";